<!-- @format -->

<ng-container *transloco="let t">
  <main class="no-sisu-account-page" role="main" data-cy="no-sisu-account-page">
    <div class="no-sisu-account-page__icon" aria-hidden="true">
      <fudis-icon [color]="'red'" [icon]="'alert-fill'" />
    </div>

    <fudis-heading [level]="1" [align]="'center'" data-cy="no-sisu-account-title">{{ t(translationScope + ".TITLE") }}</fudis-heading>
    @if (universityName$ | async; as universityName) {
      <fudis-body-text [variant]="'lg-regular'" [align]="'center'" data-cy="no-sisu-account-university"
        >{{ universityName }}
      </fudis-body-text>
    }

    <fudis-body-text class="no-sisu-account-page__message" [align]="'center'" data-cy="no-sisu-account-message">
      {{ t(translationScope + ".MESSAGE") }}
    </fudis-body-text>

    <fudis-body-text class="no-sisu-account-page__call-to-action" [align]="'center'" data-cy="no-sisu-account-call-to-action">
      {{ t("NO_SISU_ACCOUNT_PAGE.CALL_TO_ACTION") }}
    </fudis-body-text>

    <fudis-hr />

    <div class="no-sisu-account-page__action">
      <fudis-button
        [label]="t('NO_SISU_ACCOUNT_PAGE.LOGOUT_BUTTON')"
        [variant]="'secondary'"
        data-cy="no-sisu-account-logout-button"
        (handleClick)="logout()" />
    </div>
  </main>
</ng-container>
